import {
  INITIAL_DATE_BY_WEEK_GROUPING, INITIAL_DATE_BY_DAYS_GROUPING, lastModifiedByDayGrouping, submittedDateGrouping,
} from "utils/groupingHelpers"
import {
  CREATED_AT, FORM, STATUS_NAME, UPDATED_AT,
} from "utils/formSubmissionIndexHelpers"

export const groupByStatusName = (submissions, { categorySubmissionStatuses }) => {
  const initialStatusGrouping = Object.fromEntries(
    (categorySubmissionStatuses || []).map((status) => [status.name, []]),
  )

  return submissions.reduce((acc, submission) => {
    const { statusName } = submission
    if (acc[statusName]) {
      acc[statusName].push(submission)
    } else {
      acc[statusName] = [submission]
    }
    return acc
  }, initialStatusGrouping)
}

export const groupByFormTitle = (submissions) => {
  const initialFormGrouping = Object.fromEntries(
    submissions.map(({ form }) => [form.title, []]).sort(),
  )

  return submissions.reduce((acc, submission) => {
    const { title } = submission.form
    acc[title].push(submission)
    return acc
  }, initialFormGrouping)
}

export const groupByLastModified = (submissions) => submissions.reduce((acc, submission) => {
  const { updatedAt } = submission
  const groupName = lastModifiedByDayGrouping(updatedAt)
  acc[groupName].push(submission)

  return acc
}, INITIAL_DATE_BY_DAYS_GROUPING())

export const groupByDateSubmitted = (submissions) => submissions.reduce((acc, submission) => {
  const { createdAt } = submission
  const groupName = submittedDateGrouping(createdAt)
  acc[groupName].push(submission)

  return acc
}, INITIAL_DATE_BY_WEEK_GROUPING())

export const GROUPABLE_COLUMNS = {
  [STATUS_NAME]: {
    label: "Status",
    value: STATUS_NAME,
    groupingMethod: groupByStatusName,
  },
  [FORM]: {
    label: "Form",
    value: FORM,
    groupingMethod: groupByFormTitle,
  },
  [UPDATED_AT]: {
    label: "Last Modified",
    value: UPDATED_AT,
    groupingMethod: groupByLastModified,
  },
  [CREATED_AT]: {
    label: "Date Submitted",
    value: CREATED_AT,
    groupingMethod: groupByDateSubmitted,
  },
}
export const getGroupingMethod = ({ value }) => GROUPABLE_COLUMNS[value].groupingMethod
